import { mutation } from '@/dex-shared/helpers/graphql';
import AssertionModel from '@/dex-shared/models/AssertionModel';

export default {
  async CREATE_ASSERTION(
    { commit, rootState }: any,
    { questionId, position }: { questionId: number; position: number },
  ) {
    const response = await mutation(
      `mutation CreateAssertion($userId: Int!, $questionId: Int!, $position: Int!) {
        createAssertion(input: {
          assertion: {
            userId: $userId
            position: $position
            questionId: $questionId
            correct: false
          }
        }) {
          assertion {
            id
            userId
            position
            questionId
            correct
          }
        }
      }`,
      {
        userId: rootState.auth.user.id,
        position,
        questionId,
      },
    );
    commit('UPDATE_ENTITY', {
      entity: 'assertions',
      data: response.data.createAssertion.assertion,
    });
  },
  async UPDATE_ASSERTIONS(
    { dispatch }: any,
    assertions: Array<AssertionModel>,
  ) {
    return Promise.all(
      assertions.map(async (assertion: AssertionModel) => {
        return Promise.all([
          dispatch('UPDATE_CONTENTS', assertion.contents()),
          mutation(
            `mutation UpdateAssertion($id: Int!, $position: Int, $correct: Boolean) {
              updateAssertionById(input: {
                id: $id
                assertionPatch: {
                  position: $position
                  correct: $correct
                }
              }) {
                assertion {
                  id
                  questionId
                  position
                  correct
                }
              }
            }`,
            assertion.raw(),
          ),
        ]);
      }),
    );
  },
  async DELETE_ASSERTION({ commit }: any, assertionId: number) {
    let response = await mutation(
      `mutation DeleteAssertion($assertionId: Int!) {
        deleteAssertionById(input: {
          id: $assertionId
        }) {
          assertion {
            id
          }
        }
      }`,
      {
        assertionId,
      },
    );
    if (!response.errors) {
      commit('DELETE_ENTITY', {
        entity: 'assertions',
        id: assertionId,
      });
    }
  },
};
